import { Pipe, PipeTransform } from '@angular/core';
import { WebStorage } from '../../components/auth/storage/web.storage';
import * as moment from 'moment';

@Pipe({
  name: 'billingMomentDate'
})
export class BillingDatePipe implements PipeTransform {

    private timeZone: string = 'UTC'; 
    private format : string = 'MMM DD, YYYY';
    constructor(private storage : WebStorage) {
      const userdata = this.storage.getUserData();
      this.setTimeZone(userdata.schoolObj?.timeZone);
  
    }
  
    transform(value: Date | string | moment.Moment): string {
      if (!value) return '';
      const date = moment(value);    
      return date.format(this.format);
    }
    
  
    setTimeZone(timeZone: string) {
      this.timeZone = timeZone;    
    }

}
